import gql from "graphql-tag";

export const GET_USER_PERMISSIONS = gql`
  query {
    getUserPermissions {
      statusCode
      message
      data
    }
  }
`;

export const GET_USERS = gql`
  query {
    getUsers {
      statusCode
      message
      data
    }
  }
`;

export const GET_USER_COUNTRY = gql`
  query ($userLocale: String!) {
    getUserCountry(userLocale: $userLocale) {
      statusCode
      message
      data
    }
  }
`;

export const GET_USER_INFO = gql`
  query {
    getUserInfo {
      statusCode
      message
      data
    }
  }
`;
